import { render, staticRenderFns } from "./ModalEditarEmpresasVinculadas.vue?vue&type=template&id=54a09f8f&"
import script from "./ModalEditarEmpresasVinculadas.vue?vue&type=script&lang=js&"
export * from "./ModalEditarEmpresasVinculadas.vue?vue&type=script&lang=js&"
import style0 from "./ModalEditarEmpresasVinculadas.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports